import dayjs from 'dayjs';
import {RowClassParams, RowStyle} from 'ag-grid-community';

export const startDateFilters = (dateLocal: Date, dateValue: string) => {
  const date1 = dayjs(dateValue, 'DD.MM.YYYY');
  const date2 = dayjs(dateLocal);
  if (date1.isBefore(date2)) return -1;
  if (date1.isAfter(date2)) return 1;
  return 0;
}

export const defaultDateFilters = (dateLocal: Date, dateValue: string) => {
  const date1 = dayjs(dateValue.split(' ')[0], 'DD.MM.YYYY')
  const date2 = dayjs(dateLocal);
  if (date1.isBefore(date2)) return -1;
  if (date1.isAfter(date2)) return 1;
  return 0;
}

export const customRowsStyle = (params:RowClassParams):RowStyle  => {
  if (params.node.rowIndex !== null && params.node.rowIndex % 2 === 0) {
    return { background: 'var(--gx-color-header-blue)' };
  }
  return { background: 'transparent' }
}


export const getFormattedNumber = (params: any) => {
  if (Number(params.value) && params){
    return Number(params.value).toFixed(Number.isInteger(params.value) ? 0 : 2)
  }
  return (params && params.value) || params.value === 0 ? params.value : '-';
}
